module.exports = __webpack_public_path__ + "static/media/btc.1e08def6.png";